import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { whatsappLink } from "../constants/contact";

// WhatsApp glyph (marca) como SVG inline, teñido con currentColor.
const WhatsAppIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.002 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.593 4.463 1.72 6.407L3.2 28.8l6.55-1.706a12.74 12.74 0 006.252 1.633h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.053A12.72 12.72 0 0016.002 3.2zm0 23.36h-.004a10.55 10.55 0 01-5.377-1.473l-.386-.229-3.887 1.013 1.037-3.79-.251-.389a10.53 10.53 0 01-1.612-5.592c0-5.86 4.77-10.63 10.634-10.63a10.56 10.56 0 017.517 3.117 10.55 10.55 0 013.113 7.52c0 5.862-4.77 10.632-10.531 10.632zm5.82-7.965c-.319-.16-1.887-.931-2.18-1.038-.292-.107-.505-.16-.718.16-.213.319-.824 1.038-1.01 1.251-.186.213-.372.24-.69.08-.32-.16-1.347-.497-2.565-1.583-.948-.846-1.588-1.891-1.774-2.21-.186-.32-.02-.492.14-.651.144-.143.319-.372.479-.559.16-.186.213-.319.319-.532.107-.213.053-.399-.027-.559-.08-.16-.718-1.73-.984-2.369-.259-.622-.522-.538-.718-.548l-.612-.011c-.213 0-.559.08-.852.399-.293.32-1.117 1.091-1.117 2.661 0 1.57 1.144 3.087 1.303 3.3.16.213 2.252 3.438 5.456 4.821.762.329 1.357.526 1.821.674.765.243 1.462.209 2.012.127.614-.092 1.887-.771 2.153-1.516.266-.746.266-1.385.186-1.516-.08-.133-.293-.213-.612-.373z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { lang } = useLang();
  const label = lang === "es" ? "Reserva por WhatsApp" : "Book on WhatsApp";

  return (
    <motion.a
      href={whatsappLink(lang)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={label}
      initial={{ opacity: 0, y: 24, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.6, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-6 right-6 z-[55] flex items-center"
    >
      {/* Etiqueta que aparece al pasar el mouse (desktop) */}
      <span className="pointer-events-none mr-3 hidden md:inline-block rounded-full border border-white/10 bg-black/80 px-4 py-2 text-[0.7rem] uppercase tracking-[0.2em] text-zinc-200 opacity-0 translate-x-2 backdrop-blur-md transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
        {label}
      </span>

      <span className="relative flex h-14 w-14 items-center justify-center">
        {/* Anillo dorado con pulso sutil */}
        <span className="absolute inset-0 rounded-full border border-[#C5A059]/40 animate-ping opacity-60" />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#C5A059]/70 bg-[#0a0a0a] text-[#C5A059] shadow-[0_8px_30px_rgba(197,160,89,0.25)] transition-all duration-300 group-hover:bg-[#C5A059] group-hover:text-black group-hover:shadow-[0_10px_40px_rgba(197,160,89,0.45)]">
          <WhatsAppIcon />
        </span>
      </span>
    </motion.a>
  );
};
